import { useGenericMutateQuery } from 'api/hooks/use-generic-mutate-query';
import { GenericMutateQueryProps } from 'api/hooks/use-generic-mutate-query/use-generic-mutate-query.types';
import { addDesign } from './update-design';
import { UpdateDesignResponse, UpdateDesignArgs } from './update-design.types';

export const useUpdateDesign = <TransformedData = UpdateDesignResponse>(
  props?: GenericMutateQueryProps<
    UpdateDesignArgs,
    UpdateDesignResponse,
    TransformedData
  >,
) => {
  const { onMutate: onUpdateDesign, ...rest } = useGenericMutateQuery({
    fallbackErrorMessage: 'Unable to update design.',
    mutationFn: addDesign,
    ...props,
  });

  return { ...rest, onUpdateDesign };
};
